module.exports = __webpack_public_path__ + "img/finance2.1adaea5d.png";